import { usePolling } from 'hooks';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { useStores } from 'store';
import * as hmiclientbase from '../../hmilib/hmiclientbase';

interface IConnectionWrapper {
    children: React.ReactNode;
    interval?: number;
}

export const ConnectionWrapper = observer(({ children, interval = 5000 }: IConnectionWrapper) => {
    const { SystemStore } = useStores();
    const { data, startPolling, stopPolling } = usePolling(GetVerGuid, interval);

    const [verGuid, setVerGuid] = useState<string>('');
    const previousVerGuidRef = useRef<string>('');

    async function GetVerGuid() {
        return await hmiclientbase.GetVerGuid();
    }

    function stopPoll() {
        stopPolling();
        location.reload();
    }

    useEffect(() => {
        if (SystemStore.loadState) {
            startPolling();
        }
    }, [SystemStore.loadState]);

    useEffect(() => {
        if (data) {
            setVerGuid(data);
        }
    }, [data]);

    useEffect(() => {
        if (verGuid && previousVerGuidRef.current && verGuid !== previousVerGuidRef.current) {
            stopPoll();
        }
        previousVerGuidRef.current = verGuid;
    }, [verGuid]);

    return <>{children}</>;
});
